/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const i=()=>({translate:0,scale:1,origin:0,originPoint:0}),n=()=>({x:{translate:0,scale:1,origin:0,originPoint:0},y:{translate:0,scale:1,origin:0,originPoint:0}}),a=()=>({min:0,max:0}),o=()=>({x:{min:0,max:0},y:{min:0,max:0}});export{a as createAxis,i as createAxisDelta,o as createBox,n as createDelta};
//# sourceMappingURL=models.js.map
